import ClickWrapper from '@/components/ClickWrapper'
import Tooltip, { type TooltipProps } from '@/components/Tooltip'
import usePostDraft, { DraftType } from '@/utils/hooks/usePostDraft'
import useUserGuide from '@/utils/hooks/useUserGuide'
import { css, SerializedStyles } from '@emotion/react'
import { WalletIcon } from '@ruguoapp/jike-fe-icons'
import { every, isEmpty } from 'lodash-es'
import { useEffect, useState } from 'react'
import { useFormState, useWatch } from 'react-hook-form'
import { PostFormValue } from './PostForm/types'
import { RepostFormValue } from './RepostForm/types'

export interface RecoverDraftButtonProps
	extends Omit<TooltipProps, 'content' | 'position' | 'children'> {
	onRecover: (value: PostFormValue | RepostFormValue) => void
	css?: SerializedStyles
	draftType: DraftType
}

export default function RecoverDraftButton({
	onRecover,
	draftType,
	...props
}: RecoverDraftButtonProps) {
	const formValues = useWatch()
	const formState = useFormState()

	const [hasDraftRecoverTooltipSeen, markDrafRecoverTooltipSeen] =
		useUserGuide('DRAFT_RECOVER_TOOLTIP')
	const [draft, , removeDraft] = usePostDraft(draftType)
	const hasDraft = !every(draft, isEmpty)
	const [isShow, setIsShow] = useState<boolean>(hasDraft && !hasDraftRecoverTooltipSeen)

	useEffect(() => {
		if (formState.isSubmitted) {
			removeDraft()
		}
	}, [formState.isSubmitted])

	if (!draft || !hasDraft) {
		return null
	}

	return (
		<Tooltip
			content="从草稿箱中恢复未发送的内容"
			position="bottom"
			opened={isShow}
			onClose={() => {
				setIsShow(false)
				markDrafRecoverTooltipSeen()
			}}
			autoHide
			{...props}
		>
			<ClickWrapper
				onClick={() => {
					onRecover(draft)
				}}
			>
				<WalletIcon
					color="var(--tint-jike-blue)"
					css={css`
						width: 20px;
						height: 20px;
						margin: auto 0;
						display: block;
					`}
				/>
			</ClickWrapper>
		</Tooltip>
	)
}
